module.exports = __webpack_public_path__ + "static/sport/toast-3.d2f813e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/toast-3.png
// module id = sCwW
// module chunks = 0